import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Loadable from "react-loadable";
import { get, find } from "lodash";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import { getPaymentInfo, getBookingInfo } from "~/store/totalData/actions";
import { partnerInfo } from "~/configs/partnerDetails";
const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const PaymentFeeResult = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "home_desktop" */ "~/components/desktop/pages/PaymentFeeResult"
    ),
  loading: LoadableLoading
});

class DetectPaymentFeeResult extends Component {
  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);

    const mpTransaction = urlParams.get("mpTransaction");
    const code = urlParams.get("code");
    if (mpTransaction !== null) {
      this.props.getPaymentInfo(mpTransaction, "hospitalFee");
    } else if (code !== null) {
      this.props.getBookingInfo(code, "hospitalFee");
    }
  }

  render() {
    return (
      <React.Fragment>
        <PaymentFeeResult {...this.props} {...this.methods} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    totalData: { paymentInformation, loading }
  } = state;
  return {
    device: type,
    paymentInformation,
    loading
  };
};

const PaymentFeeResultHelmet = withTitle({
  component: DetectPaymentFeeResult,
  title: `${hospitalName.value} | Kết quả thanh toán viện phí`
});

export default connect(mapStateToProps, { getPaymentInfo, getBookingInfo })(
  withRouter(PaymentFeeResultHelmet)
);
